/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import { serializeForm, fetchConfig } from './global';

class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  handleCartItemInventory(itemID) {
    let isItemInCart = false;
    this.cartNotification.setActiveElement(document.activeElement);
    const submitButton = this.querySelector('[type="submit"]');

    fetch('/cart?view=mini')
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const cartContent = parser.parseFromString(html, 'text/html');
        const quantityInputs = cartContent.querySelectorAll('.quantity__input');
        if (quantityInputs) {
          quantityInputs.forEach((quantityInput) => {
            if (quantityInput.dataset.variantId === itemID) {
              submitButton.setAttribute('disabled', true);
              submitButton.classList.add('loading');
              isItemInCart = true;

              const newItemQuantity = Number(quantityInput.value) + 1;
              fetch(`/cart/change?id=${itemID}&quantity=${newItemQuantity}`, {
                method: 'post',
              })
                .then(() => {
                  this.cartNotification.renderContents({ itemID, itemQuantiy: quantityInput.value });
                  window.updateCartCount();
                })
                // eslint-disable-next-line no-console
                .catch((e) => console.error(e))
                .finally(() => {
                  submitButton.classList.remove('loading');
                  submitButton.removeAttribute('disabled');
                });
            }
          });

          if (!isItemInCart) {
            const body = JSON.stringify({
              ...JSON.parse(serializeForm(this.form)),
              sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname,
            });

            submitButton.setAttribute('disabled', true);
            submitButton.classList.add('loading');

            fetch(`${window.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
              .then((response) => response.json())
              .then(() => {
                this.cartNotification.renderContents();
                window.updateCartCount();
              })
              // eslint-disable-next-line no-console
              .catch((e) => console.error(e))
              .finally(() => {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('disabled');
              });
          }
        }
      })
      // eslint-disable-next-line no-console
      .catch((err) => console.warn('Something went wrong.', err));
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    const formData = JSON.parse(serializeForm(this.form));
    if (formData.id) {
      this.handleCartItemInventory(formData.id);
    }
  }
}

customElements.get('product-form') || customElements.define('product-form', ProductForm); // eslint-disable-line

const ModalDialog = customElements.get('modal-dialog');
class ProductModal extends ModalDialog {
  constructor() { // eslint-disable-line
    super();
  }

  hide() {
    super.hide();
    window.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`).forEach((element) => {
      element.classList.remove('active');
    });
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();

    if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMedia.querySelector('template').content.querySelector('.js-youtube')) activeMedia.loadContent();
  }
}

customElements.get('product-modal') || customElements.define('product-modal', ProductModal); // eslint-disable-line

const labels = document.querySelectorAll('.product-form__inputradio .radioselect');
const changeActive = (e) => {
  [...labels].forEach((label) => label.classList.remove('active'));
  e.target.classList.add('active');
  const buttonID = e.target.getAttribute('data-button-id');
  document.querySelector('.product-form-wrap__size fieldset').setAttribute('data-width-button', buttonID);

  const firstAvailableVariantInput = document.querySelector(`variant-radios fieldset input:not(.disabled)[name="Size"][data-width-type="${buttonID}"]`);
  if (firstAvailableVariantInput) firstAvailableVariantInput.checked = true;

  // update size chart selector
  const sizeChartSelector = document.querySelector(`.product-form__inputdrawer .radioselect[data-button-id="${buttonID}"]`);
  if (sizeChartSelector) {
    document.querySelectorAll('.product-form__inputdrawer label').forEach((label) => label.classList.remove('active'));
    document.querySelector('.switch--btn_drawer').setAttribute('data-button', buttonID);
    sizeChartSelector.classList.add('active');
  }

  const activeDrawerLabel = document.querySelector(`.product-form__inputdrawer label[data-button-id="${buttonID}"]`);
  if (activeDrawerLabel) activeDrawerLabel.click();
};

[...labels].forEach((e) => e.addEventListener('click', changeActive));

document.addEventListener('DOMContentLoaded', () => {
  const firstAvailableVariantInput = document.querySelector('variant-radios fieldset input:not(.disabled)[name="Size"]');
  [...labels].forEach((label) => {
    if (label.dataset.buttonId === firstAvailableVariantInput.dataset.widthType) {
      label.click();
      firstAvailableVariantInput.click();
    } else {
      label.classList.remove('active');
    }
  });
});

/*  switch regular/narrow sizecharts in drawer */
const drawerLabels = document.querySelectorAll('.product-form__inputdrawer label');
const changeActiveDrawer = (e) => {
  [...drawerLabels].forEach((label) => label.classList.remove('active'));
  e.target.classList.add('active');
  const buttonDrawerId = e.target.getAttribute('data-button-id');
  document.querySelector('.switch--btn_drawer').setAttribute('data-button', buttonDrawerId);

  document.querySelectorAll('.sizes-info .accordion').forEach((element) => {
    element.classList.remove('active');
    if (element.dataset.fit === buttonDrawerId) element.classList.add('active');
  });

  // update width variant selector
  const widthSelector = document.querySelector(`.product-form__inputradio .radioselect[data-button-id="${buttonDrawerId}"]`);
  if (widthSelector) {
    document.querySelectorAll('.product-form__inputradio .radioselect').forEach((label) => label.classList.remove('active'));
    document.querySelector('.product-form-wrap__size fieldset').setAttribute('data-width-button', buttonDrawerId);
    widthSelector.classList.add('active');
  }

  const firstAvailableVariantInput = document.querySelector(`variant-radios fieldset input:not(.disabled)[name="Size"][data-width-type="${buttonDrawerId}"]`);
  if (firstAvailableVariantInput) firstAvailableVariantInput.checked = true;
};
[...drawerLabels].forEach((e) => e.addEventListener('click', changeActiveDrawer));

const drawerButtonTrigger = (e) => {
  const openDrawer = document.querySelector('.product-info-drawer');
  document.body.classList.add('open-drawer');
  openDrawer.classList.add('active');
  if (e.target.classList.contains('sizes')) {
    document.querySelector('.sizes-info').classList.add('open');
    document.querySelector('.width-info').classList.remove('open');
    document.querySelector('.get-notified-info').classList.remove('open');
  } else if (e.target.classList.contains('get-notified')) {
    document.querySelector('.get-notified-info').classList.add('open');
    document.querySelector('.width-info').classList.remove('open');
    document.querySelector('.sizes-info').classList.remove('open');
  } else if (e.target.classList.contains('get-notified-mobile')) {
    openDrawer.classList.remove('active');
    document.querySelector('.product-info-drawer__mobile').classList.add('active');
  } else {
    document.querySelector('.width-info').classList.add('open');
    document.querySelector('.sizes-info').classList.remove('open');
    document.querySelector('.get-notified-info').classList.remove('open');
  }

  const activeButton = document.querySelector('.product-form__inputradio .radioselect.active[data-button-id]')
    || document.querySelector('.product-form__inputdrawer label.active[data-button-id]');
  if (activeButton) {
    const activeDrawerLabel = document.querySelector(`.product-form__inputdrawer label[data-button-id="${activeButton.dataset.buttonId}"]`);
    if (activeDrawerLabel) activeDrawerLabel.click();
  }
};
const drawerButtons = document.querySelectorAll('.product-form__drawer');
[...drawerButtons].forEach((e) => e.addEventListener('click', drawerButtonTrigger));

document.querySelector('.product-width-info__close').addEventListener('click', () => {
  document.querySelector('.product-info-drawer').classList.remove('active');
  document.body.classList.remove('open-drawer');
});
document.querySelector('.product-width-info-mobile__close').addEventListener('click', () => {
  document.querySelector('.product-info-drawer__mobile').classList.remove('active');
});

function checkMobile(x) {
  try {
    if (x.matches) {
      document.getElementById('BIS_trigger').className = 'get-notified-mobile';
    } else {
      document.getElementById('BIS_trigger').className = 'get-notified';
    }
  // eslint-disable-next-line no-empty
  } catch (error) {}
}

const x = window.matchMedia('(max-width: 700px)');
checkMobile(x);
x.addListener(checkMobile);

let scrollPos = 807;
function checkPosition() {
  const windowY = window.scrollY;
  if (windowY < scrollPos) {
    // scroll up code block
  } else {
    document.querySelector('.button-addtocart-sticky').classList.add('slideUp');
  }
  scrollPos = windowY;

  const element = document.querySelector('#ButtonAddToCart');
  const position = element.getBoundingClientRect();
  if (position.top < window.innerHeight && position.bottom >= 0) {
    document.querySelector('.button-addtocart-sticky').classList.remove('slideUp');
  }
}

window.addEventListener('scroll', checkPosition);

document.addEventListener('DOMContentLoaded', () => {
  const productInfoDrawer = document.querySelector('.product-info-drawer.visually-hidden');
  if (productInfoDrawer) {
    productInfoDrawer.classList.remove('visually-hidden');
  }
});
